module.exports = __webpack_public_path__ + "img/white_facebook.816b8039.svg";